<template>
<!-- 题目管理 列表页 -->
    <div class="board">
        <div  v-hasPermi="['questionBank:question:list']">
            <div class="title">
                <span>
                    <el-button
                            type="text"
                            icon="el-icon-arrow-left"
                            @click="$router.push('/questionBank')">
                        {{ questionTextConfig.back }}
                    </el-button>
                    <el-divider direction="vertical"></el-divider>
                    <span class="name">{{ questionTextConfig.title }}</span>
                </span>
                <div>
                    <el-dropdown
                            @command="handleCommand"
                            trigger="click"
                            v-hasPermi="['questionBank:question:add']">
                        <el-button type="primary">
                            {{ questionTextConfig.add }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                                    v-for="item in dropdownList"
                                    :key="item.dict_value"
                                    :command="item.dict_value">
                                {{item.dict_label}}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button
                            v-hasPermi="['questionBank:question:batch']"
                            type="primary"
                            @click="importDialogVisible = true"
                            style="margin-left:10px">
                        {{ tableButtonTextConfig.import.name }}
                    </el-button>
                </div>
            </div>
            <p class="info"
               v-hasPermi="['questionBank:bank:info']">
                <span>{{ questionTextConfig.questionBank }}：</span>{{info.name}} <span>
                {{ dropdownListFormatter('single_choice') }}：</span>{{info.single_choice_num}} <span>
                {{ dropdownListFormatter('choice') }}：</span>{{info.choice_num}} <span>
                {{ dropdownListFormatter('uncertain_choice') }}：</span>{{info.uncertain_choice_num}} <span>
                {{ dropdownListFormatter('determine') }}：</span>{{info.determine_num}} <span>
                {{ dropdownListFormatter('fill') }}：</span>{{info.fill_num}} <span>
                {{ dropdownListFormatter('subjectivity') }}：</span>{{info.subjectivity_num}}
            </p>
            <el-form :inline="true" :model="form" ref="form">
                <el-form-item>
                    <el-input v-model="form.stem" clearable :placeholder="searchTextConfig.stem"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="form.type" clearable :placeholder="searchTextConfig.type">
                        <el-option
                                v-for="item in dropdownList"
                                :key="item.dict_value"
                                :label="item.dict_label"
                                :value="item.dict_value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="form.difficulty" clearable :placeholder="searchTextConfig.difficulty">
                        <el-option
                                v-for="item in difficultyOptions"
                                :key="item.dict_value"
                                :label="item.dict_label"
                                :value="item.dict_value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-cascader
                            v-model="tag_ids"
                            @change="tagCheck"
                            :placeholder="searchTextConfig.tag"
                            :options="tagOptions"
                            :props="tagProps"
                            collapse-tags
                            :show-all-levels="false"
                            filterable
                            clearable>
                        <template slot-scope="{ node, data }">
                            <span>{{ data.name }}</span>
                            <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                        </template>
                    </el-cascader>
                </el-form-item>

                <el-form-item>
                    <el-select
                        v-model="form.training_label"
                        clearable
                        filterable
                        allow-create
                        default-first-option
                        :placeholder="searchTextConfig.training">
                        <el-option :label="searchTextConfig.nullTraining" :value="searchTextConfig.nullTraining"></el-option>
                        <el-option v-for="f in trainingOptions" :key="f.label" :label="f.label" :value="f.label" :platformMark="f.platform_mark"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select
                        v-model="form.review_mode"
                        clearable
                        :placeholder="searchTextConfig.reviewMethod">
                        <el-option
                            v-for="item in reviewModeOptions"
                            :key="item.id"
                            :label="item.dict_label"
                            :value="item.dict_value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-select
                            v-model="form.status"
                            clearable
                            :placeholder="searchTextConfig.status">
                        <el-option
                                v-for="item in statusOptions"
                                :key="item.dict_value"
                                :label="item.dict_label"
                                :value="item.dict_value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search(1)">{{ searchTextConfig.select }}</el-button>
                    <el-button @click="reset">{{ searchTextConfig.reset }}</el-button>
                </el-form-item>
            </el-form>
            <p class="info">
                <span>已选：<i>{{selectRow.length}}</i>/{{tableData.length||0}} </span>
                <el-button
                        v-hasPermi="['questionBank:question:delete']"
                        :disabled="!selectRow.length"
                        @click="batchDelete"
                        type="danger"
                        size="mini"
                        style="margin-left:10px">
                    {{ tableButtonTextConfig.batchDelete.name }}
                </el-button>
                <el-button
                        v-hasPermi="['questionBank:question:update']"
                        :disabled="!selectRow.length"
                        @click="difficultyDialogVisible = true"
                        type="primary"
                        size="mini">
                    {{ tableButtonTextConfig.setNumber.name }}
                </el-button>
                <el-button
                        v-hasPermi="['questionBank:question:update']"
                        :disabled="!selectRow.length"
                        @click="scoreDialogVisible = true"
                        type="primary"
                        size="mini">
                    {{ tableButtonTextConfig.setScore.name }}
                </el-button>
            </p>
            <el-table
                    v-loading="loading"
                    element-loading-text="加载中"
                    element-loading-spinner="el-icon-loading"
                    ref="multipleTable"
                    :data="tableData"
                    @selection-change="handleSelectionChange"
                    stripe
                    size="medium"
                    :height="height"
                    style="width:100%">
                <el-table-column type="selection" width="48" fixed="left" align="center"></el-table-column>
                <el-table-column
                        prop="stem"
                        :label="tableTextConfig.stem"
                        :min-width="flexColumnWidth('stem',2,tableData)"
                        show-overflow-tooltip>
                    <template slot-scope="scope">
                        <a v-if="questInfoPermissions"
                           @click="$router.push({ name: 'questionPreview', query: { id: scope.row.id, parentId: id}})">
                            {{scope.row.stem}}
                        </a>
                        <span v-else>{{scope.row.stem}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="score"
                        :label="tableTextConfig.score"
                        min-width="65"
                        show-overflow-tooltip>
                    <template slot-scope="scope">{{ tableTextConfig.scoreFormatter.signMix(scope.row.score) }}</template>
                </el-table-column>
                <el-table-column prop="type" :label="tableTextConfig.type" min-width="65">
                    <template slot-scope="scope">{{scope.row.type | formatType(dropdownList)}}</template>
                </el-table-column>
                <el-table-column prop="number" :label="tableTextConfig.number" min-width="60">
                    <template slot-scope="scope">{{ difficultyFormatter(scope.row.difficulty) }}</template>
                </el-table-column>
                <el-table-column prop="tags" :label="tableTextConfig.tags" :min-width="flexColumnWidth('tags',3,tableData)" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-for="item in scope.row.tags" :key="item.id"><el-tag type="info">{{item.name}}</el-tag>&nbsp;&nbsp;</span>
                        {{ !(scope.row.tags && scope.row.tags.length > 0) ? '无' : '' }}
                    </template>
                </el-table-column>

                <el-table-column prop="training_label" :label="tableTextConfig.training" min-width="100"></el-table-column>
                <el-table-column prop="review_mode" :label="tableTextConfig.reviewMethod" min-width="100" :formatter="reviewModelFormatter"></el-table-column>

                <el-table-column prop="update" :label="tableTextConfig.update" min-width="140px">
                    <template slot-scope="scope">
                        <p>{{scope.row.updated_by_username}}</p>
                        <p class="updateDate">{{scope.row.updated_at | formatTime}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="status" :label="tableTextConfig.status" min-width="80px">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status==0?'info':''">{{ statusFormatter(scope.row.status) }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" :label="tableTextConfig.operate" min-width="210px">
                    <template slot-scope="scope">
                        <el-button
                                v-hasPermi="['questionBank:question:update']"
                                size="mini"
                                plain
                                type="primary"
                                @click="$router.push({ name: 'questionEdit', query: { editId: scope.row.id, type: scope.row.type, parentId: id }})">
                            {{ tableButtonTextConfig.edit }}
                        </el-button>
                        <el-button
                            size="mini"
                            plain
                            type="primary"
                            @click="$router.push({ name: 'questionCopy', query: { editId: scope.row.id, type: scope.row.type, parentId: id }})">
                            复制
                        </el-button>
                        <el-button
                                v-hasPermi="['questionBank:question:delete']"
                                size="mini"
                                plain
                                type="danger"
                                @click="delet(scope.row.id)"
                                :disabled="scope.row.status === 1">
                            {{ tableButtonTextConfig.delete.name }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination v-show="tableData.length" :currentPage.sync="form.page_number" :pageSize.sync="form.page_size" :total.sync="total"></pagination>
            <edit-dialog :row="row" :show.sync="editDialogVisible" @close="close"></edit-dialog>
            <import-dialog :show.sync="importDialogVisible" @close="close"></import-dialog>
            <set-dialog :setDifficultyShow.sync="difficultyDialogVisible" :setScoreShow.sync="scoreDialogVisible" :row="selectRow" @close="close"></set-dialog>
        </div>
    </div>
</template>

<script>
import pagination from '@/components/pagination/pagination.vue'
import editDialog from './dialog/edit.vue'
import importDialog from './dialog/import.vue'
import setDialog from './dialog/set.vue'
import { judgePermissions } from '@/utils/common.js'
import {getDict} from "@/api/dict"

export default {
    name: 'question',
    components: {
        editDialog, importDialog, setDialog, pagination
    },
    inject: ['reload'],
    data() {
        return {
            questInfoPermissions: false,
            dropdownList: [],
            height:250,
            info: {
                choice_num: 0,
                determine_num: 0,
                fill_num: 0,
                id: "",
                name: "",
                question_num: 0,
                single_choice_num: 0,
                subjectivity_num: 0,
                uncertain_choice_num: 0
            },
            loading: true,
            id: '',
            form: {
                stem: '',
                type: '',
                difficulty: '',
                tag_ids: '',
                training_mirror: '',
                review_mode: '',
                status: '',
                page_number: 1,
                page_size: 20
            },
            tag_ids: '',
            total: 0,
            difficultyOptions: [],
            statusOptions: [],
            tagProps: { multiple: true, expandTrigger: 'hover', emitPath: false, value: 'id', label: 'name' },
            tagOptions: [],
            selectRow: [],
            tableData: [],
            editDialogVisible: false,
            importDialogVisible: false,
            difficultyDialogVisible: false,
            scoreDialogVisible: false,
            row: null,
            trainingOptions: [],
        }
    },
    computed: {
        questionTextConfig() {
            return this.$store.state.global.textConfig.backend.question
        },
        searchTextConfig() {
            return this.questionTextConfig.search
        },
        tableTextConfig() {
            return this.questionTextConfig.table
        },
        tableButtonTextConfig() {
            return this.questionTextConfig.table.button
        },
        reviewModeOptions() {
            return this.$store.state.question.reviewModeOptions
        },
    },
    beforeRouteEnter(to, from, next) {
        if (from.name === 'questionBank') {
            next(vm => {
                vm.reload()
            })
        } else if (from.name === 'questionPreview' || from.name === 'questionEdit' || from.name === 'verification') {
            to.meta.isBack = true
            next()
        } else {
            to.meta.isBack = false
            next()
        }
    },
    watch: {
        tableData () {
            if (this.tableData.length == 0) {
                this.height = 120
            }else {
                this.updateHeight()
            }
        }
    },
    created() {
        let id = this.$route.query.id
        getDict('question_type').then(res => {
            this.dropdownList = res.data
        })
        getDict('question_difficulty').then(res => {
            this.difficultyOptions = res.data
        })
        getDict('question_status').then(res => {
            this.statusOptions = res.data
        })
        getDict('review_mode').then(res => {
            this.$store.state.question.reviewModeOptions = res.data
        })
        getDict('submit_mode').then(res => {
            this.$store.state.question.submitModeOptions = res.data
        })
        this.$store.dispatch("getTrainingMirrorList").then(res => {
            this.trainingOptions = res.data
        })
        this.$store.dispatch("getManageInfo", id).then(res => {
            this.info = res.data
            this.id = res.data.id
            this.search(1)
        })
        this.$store.dispatch("getQuestionTagList").then(res => {
            this.tagOptions = []
            for (let i = 0; i < res.data.length; i++) {
                const e = res.data[i];
                if (i!=(res.data.length-1)) {
                    this.tagOptions.push(e)
                }else {
                    this.tagOptions.push(...e.children)
                }
            }
        });
        this.judgePermissions(['questionBank:question:info']).then(res => {
            if (res) {
                this.questInfoPermissions = true
            }
        })
    },
    mounted() {
        const that = this;
        setTimeout(() => {
            that.updateHeight()
        }, 200);
        window.onresize = () => {
            that.updateHeight()
        };
    },
    methods: {
        judgePermissions,
        handleCommand(command) {
            this.$router.push({ name: 'questionEdit', query: { id: this.id, type: command, parentId: this.id}})
        },
        tagCheck() {
            this.form.tag_ids = this.tag_ids.join(',')
        },
        search(val) {
            this.loading = true
            if (val) {
                this.form.page_number = val
            }
            this.$store.dispatch("getManageList", {id:this.id,form:this.form}).then(res => {
                this.loading = false
                this.tableData = res.data.list
                for (let i = 0; i < this.tableData.length; i++) {
                    const e = this.tableData[i];
                    e.stem = e.stem.replace(/<img[^>]*[>|...]/g,'【图片】')
                    if (e.type == 'fill') {
                        e.stem = (e.stem.replace(/\[\[(.*?)\]\]/g,'________________')).replace(/<[^<>]+>/g,'')
                    }else {
                        e.stem = e.stem.replace(/<[^<>]+>/g,'')
                    }
                }
                this.total = res.data.total
                this.form.page_number = res.data.pageNumber
                this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
            }).catch(err => {
                this.loading = false
            })

            this.$nextTick(()=>{
                this.$refs.multipleTable.doLayout()
            })
        },
        reset() {
            this.form = this.$options.data().form
            this.tag_ids = ''
            this.form.page_size = 20
            this.search(1)
        },
        handleSelectionChange(val) {
            this.selectRow = []
            for (let i = 0; i < val.length; i++) {
                const e = val[i];
                this.selectRow.push(e)
            }
        },
        batchDelete() {
            let row = []
            for (let j = 0; j < this.selectRow.length; j++) {
                const e = this.selectRow[j];
                if (e.status == 0) {
                    row.push(e.id)
                }
            }
            let deleteTextConfig = this.tableButtonTextConfig.batchDelete
            this.$confirm(deleteTextConfig.message.signMix(this.selectRow.length), deleteTextConfig.title, {
                confirmButtonText: deleteTextConfig.ok,
                cancelButtonText: deleteTextConfig.cancel,
                type: 'warning'
            }).then(() => {
                if (row.length == 0) {
                    this.$message({
                        type: 'warning',
                        message: deleteTextConfig.error.signMix(this.selectRow.length)
                    });
                }else{
                    this.$store.dispatch("batchDeleteManageQuestion", row.join(',')).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                type: 'success',
                                message: deleteTextConfig.success
                            });
                            this.search(1)
                        }
                    })
                }
            }).catch(() => {});
        },
        delet(id) {
            let deleteTextConfig = this.tableButtonTextConfig.delete
            this.$confirm(deleteTextConfig.message, deleteTextConfig.title, {
                confirmButtonText: deleteTextConfig.ok,
                cancelButtonText: deleteTextConfig.cancel,
                type: 'warning'
            }).then(() => {
                this.$store.dispatch("deleteManageQuestion", id).then(res => {
                    if (res.status == 200) {
                        this.$message({
                            type: 'success',
                            message: deleteTextConfig.success
                        });
                        if (this.tableData.length == 1) {
                            let num = this.form.page_number==1?1:this.form.page_number-1
                            this.search(num)
                        }else {
                            this.search()
                        }
                    }
                });
            }).catch(() => {});
        },
        close(data) {
            this.editDialogVisible = data
            this.importDialogVisible = data
            this.difficultyDialogVisible = false
            this.scoreDialogVisible = false
        },
        updateHeight() {
            this.height = document.getElementsByClassName('board')[0].clientHeight - document.getElementsByClassName('el-form')[0].clientHeight - 222
            this.height = this.height < 460 ? 460 : this.height
        },
        statusFormatter(val) {
            let already = this.statusOptions.find(item => item.dict_value == val)
            return already ? already.dict_label : ''
        },
        dropdownListFormatter(val) {
            let already = this.dropdownList.find(item => item.dict_value == val)
            return already ? already.dict_label : ''
        },
        difficultyFormatter(val) {
            let already = this.difficultyOptions.find(item => item.dict_value == val)
            return already ? already.dict_label : ''
        },
        reviewModelFormatter(row) {
            if (row.type === 'subjectivity') {
                let already = this.reviewModeOptions.find(item => item.dict_value === row.review_mode)
                return already ? already.dict_label : ''
            } else {
                return '客观题系统评阅'
            }
        }
    }
}
</script>

<style scoped>
.info {
    color: #555;
    font-size: 15px;
    margin-bottom: 12px;
}
.info span {
    color: #C0C4CC;
    margin-left: 12px;
}
.info span:first-child {
    margin-left: 0;
}
.info i {
    color: #555;
}
</style>
